module.exports = __webpack_public_path__ + "img/stopNum.aa3aaf6e.png";